import { TDeliverySettings } from '@app/api/deliveryApi/deliveryApi';

/* eslint-disable no-unsafe-optional-chaining */
const streets: string[] = [
  'улица',
  'проспект',
  'бульвар',
  'переулок',
  'проезд',
  'набережная',
  'тупик',
  'площадь',
  'сквер',
  'шоссе',
  'автодорога',
  'тракт',
  'аллея',
  'линия',
];

export function getAddressFromGeocode(address: string): {
  city: string;
  street: string;
  house: string;
} {
  const addressArr = address.split(',').map((item: string) => item.trim());
  let house = '';
  let street = '';
  let city = '';
  if (!streets.some((element) => addressArr[addressArr?.length - 1].toLowerCase().includes(element.toLowerCase()))) {
    house = addressArr[addressArr?.length - 1];
    if (streets.some((element) => addressArr[addressArr?.length - 2].toLowerCase().includes(element.toLowerCase()))) {
      street = addressArr[addressArr?.length - 2];
      city = addressArr.slice(0, addressArr?.length - 2).join(', ');
    } else {
      city = addressArr.slice(0, addressArr?.length - 1).join(', ');
    }
  } else if (
    streets.some((element) => addressArr[addressArr?.length - 1].toLowerCase().includes(element.toLowerCase()))
  ) {
    street = addressArr[addressArr?.length - 1];
    city = addressArr.slice(0, addressArr?.length - 1).join(', ');
  } else {
    city = addressArr.join(', ');
  }

  return {
    city,
    street,
    house,
  };
}

export function isSameDay(date1: Date, date2: Date): boolean {
  return (
    date1.getFullYear() === date2.getFullYear() &&
    date1.getMonth() === date2.getMonth() &&
    date1.getDate() === date2.getDate()
  );
}

type TGeoObject = {
  geometry: {
    type: string;
    coordinates: number[][][];
    fillRule: string;
  };
  properties: {
    balloonContent: string;
    visual: {
      fillColor: string;
      strokeColor: string;
      fillOpacity: number;
      strokeWidth: string;
      strokeOpacity: number;
    };
  };
};

export function serializeMapData(data: TDeliverySettings): TGeoObject[] {
  const deliveryObject = data.map.features;
  const mappedDelivery = deliveryObject.map((item) => {
    const returnData: TGeoObject = {
      // Описываем геометрию геообъекта.
      geometry: {
        // Тип геометрии - "Многоугольник".
        type: 'Polygon',
        // Указываем координаты вершин многоугольника.
        coordinates: item.geometry.coordinates.map((coordinates) => coordinates.map((subItem) => subItem.reverse())),
        // Задаем правило заливки внутренних контуров по алгоритму "nonZero".
        fillRule: 'nonZero',
      },
      // Описываем свойства геообъекта.
      properties: {
        // Содержимое балуна.
        balloonContent: item.properties.description,
        visual: {
          // Описываем опции геообъекта.
          // Цвет заливки.
          fillColor: item.properties.fill,
          // Цвет обводки.
          strokeColor: item.properties.stroke,
          // Общая прозрачность (как для заливки, так и для обводки).
          fillOpacity: item.properties['fill-opacity'],
          // Ширина обводки.
          strokeWidth: item.properties['stroke-width'],
          strokeOpacity: item.properties['stroke-opacity'],
        },
      },
    };
    return returnData;
  });
  return mappedDelivery;
}
